import React, { Fragment } from 'react'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Text from 'components/_new/typography/Text/Text'
import Href from 'components/_new/ui/Href/Href'

import messages from './messages'
import s from './FooterSocials.scss'

import instagramIcon from './images/instagram.svg'
import facebookIcon from './images/facebook.svg'
import twitterIcon from './images/twitter.svg'
import pinterestIcon from './images/pinterest.svg'


const socials = [
  {
    image: instagramIcon,
    link: 'https://instagram.com/scentbird/',
    name: 'Instagram',
    ariaLabel: 'Instagram',
  },
  {
    image: facebookIcon,
    link: 'https://www.facebook.com/scentbird',
    name: 'Facebook',
    ariaLabel: 'Facebook',
  },
  {
    image: twitterIcon,
    link: 'https://www.twitter.com/scentbird',
    name: 'Twitter',
    ariaLabel: 'Twitter',
  },
  {
    image: pinterestIcon,
    link: 'https://www.pinterest.com/scentbird/',
    name: 'Pinterest',
    ariaLabel: 'Pinterest',
  },
]

const FooterSocials = () => (
  <Fragment>
    <Box mt="24">
      {
        socials.map(({ image, link, name, ariaLabel }) => (
          <Box key={link} mr="24" inline>
            <Href className={s.social} toTab={link} aria-label={ariaLabel}>
              <Image src={image} alt={name} />
            </Href>
          </Box>
        ))
      }
    </Box>
    <Box mt="24">
      <Box mr="16" inline>
        <Href to={links.privacy}>
          <Text muted size="14-24" message={messages.privacyPolicy} />
        </Href>
      </Box>
      <Box inline>
        <Href to={links.terms}>
          <Text muted size="14-24" message={messages.terms} />
        </Href>
      </Box>
    </Box>
  </Fragment>
)


export default FooterSocials
